/*************************************************/
/* CTA BUTTON                                    */
/*************************************************/
export function ctaButton() {
    document.querySelectorAll('.cta-button.primary, .cta-button.secondary, .cta-button.arrow, .banner__link, .banner__link2, .media-content__link, .split-image-content__link, .facts-blocks__link, .facts-block__link').forEach(el => {
        const target = el.tagName === 'A' ? el : el.querySelector('a');
        if (target && !target.querySelector('.cta-button__icon')) {
            const icon = document.createElement('span');
            icon.className = 'cta-button__icon';
            icon.setAttribute('aria-hidden', 'true');
            target.appendChild(icon);
        }
    });
}
